(function(){
  // Idempotency guard: if a Shopify section reload re-inserts this script tag, do nothing.
  // The original q-1.js + q-2.js bundle uses let-declared module-scope vars; re-running it
  // would throw "Identifier already declared". The section-reload handler inside q-2.js
  // takes care of re-querying DOM refs and re-binding listeners after a section reload.
  // q-3.js attaches a MutationObserver fallback for builds where Shopify doesn't reliably
  // fire shopify:section:load on setting edits.
  if (window.__tstQLoaderRan) return;
  window.__tstQLoaderRan = true;
  var script = document.currentScript;
  if (!script) { var s = document.querySelectorAll('script[src*="questionnaire.js"]'); script = s[s.length-1]; }
  if (!script) { console.warn('[TST] loader cannot find <script>'); return; }
  var src = script.src;
  var q = src.indexOf('?'); var query = q >= 0 ? src.substring(q) : '';
  var base = src.substring(0, src.lastIndexOf('/') + 1);
  var urls = [base + 'questionnaire-1.js' + query, base + 'questionnaire-2.js' + query, base + 'questionnaire-3.js' + query];
  Promise.all(urls.map(function(u){ return fetch(u).then(function(r){ if(!r.ok) throw new Error(u); return r.text(); }); }))
    .then(function(parts){ var s = document.createElement('script'); s.textContent = parts.join('\n'); document.head.appendChild(s); })
    .catch(function(e){ console.error('[TST] loader error', e); });
})();
